import { NavLink } from 'react-router-dom'
import { IconArrowRight } from '../Icons'
import classnames from 'classnames'
import { useLocation } from 'react-router-dom'


export const TabSettings:React.FC = () => {

  const location = useLocation()

  return (
    <nav className="tabnav-wrapper">
      <NavLink to={{ pathname: '/' }} className={classnames('tabnav-tab', { 'tabnav-tab--active': location.pathname === '/' })}>
        Unpaid Invoices
        <span className="tabnav-tab__arrow"><IconArrowRight color="#ffffff" /></span>
      </NavLink>
      <NavLink to={{ pathname: '/invoices/paid' }} className={classnames('tabnav-tab', { 'tabnav-tab--active': location.pathname === '/invoices/paid' })}>
        Paid Invoices
        <span className="tabnav-tab__arrow"><IconArrowRight color="#ffffff" /></span>
      </NavLink>
    </nav>
  )
}


export default TabSettings